<template>
  <el-dialog
    center
    :visible="show"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
    top="10vh"
    width="50%"
    title="分配次数编辑"
    v-if="show"
  >
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="归属部门">
        {{ item.dep.branch }}-{{ item.dep.dep }}-{{ item.dep.group }}
      </el-form-item>
      <el-form-item label="工号"> {{ item.username }} </el-form-item>
      <el-form-item label="姓名"> {{ item.realname }} </el-form-item>
      <el-form-item label="分配设定">
        <el-switch
          v-model="form.allocation_status"
          :active-value="1"
          :inactive-value="2"
        ></el-switch>
        <span v-show="form.allocation_status !== 2">
          <span style="margin: 0 10px">分配次数</span>
          <el-input-number
            size="mini"
            v-model="form.allocation_times"
            controls-position="right"
            :min="min"
            :max="max"
            :step="1"
            step-strictly
          ></el-input-number>
          <span style="margin-left: 10px"
            >剩余
            <span style="font-weight: bold">
              {{ new_lave_num }}
            </span>
          </span>
          <span style="color: gray; margin-left: 10px"
            >*在队列中的重复分配次数</span
          >
        </span>
      </el-form-item>
      <el-form-item>
        <!-- <div v-if="min !== 0" style="color: red">
          保存失败，组下设定的分配数量过少，请重新调整
        </div> -->
        <el-button type="primary" @click="submit">保存</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { getBackEndGroupLave, seAllocationtTimes } from "./api";
export default {
  name: "EditDIalog",
  props: {
    show: {
      type: Boolean,
    },
    item: {
      type: Object,
    },
    queueId: {
      type: [Number, String],
    },
  },
  data() {
    return {
      form: {
        allocation_times: 0,
        allocation_status: 0,
      },
      lave_num: 0,
      can_num: 0,
      allocation_times_sum: 0,
    };
  },
  mounted() {},
  watch: {
    async show(val) {
      if (val) {
        await this.init();
      }
    },
  },
  computed: {
    max() {
      return this.item.allocation_times + this.lave_num;
    },
    min() {
      let num =
        Math.ceil(this.can_num / 2) -
        this.allocation_times_sum +
        this.item.allocation_times;
      return num < 1 ? 1 : num;
    },
    new_lave_num() {
      return (
        this.lave_num -
        (this.form.allocation_times - this.item.allocation_times)
      );
    },
  },
  methods: {
    close() {
      this.$emit("update:show", false);
    },
    async submit() {
      if (this.loading) return;
      this.loading = true;
      let req = await seAllocationtTimes({
        queue_id: this.queueId,
        group_id: this.item.dep.group_id,
        username: this.item.username,
        ...this.form,
      });
      let { code, msg } = await req.json();
      this.loading = false;
      if (code !== 200) {
        this.$message.error(msg);
        return;
      }
      this.$message.success("保存成功");
      this.$emit("callback");
      this.close();
    },
    cancel() {
      this.close();
    },
    async init() {
      let { data } = await getBackEndGroupLave({
        queue_id: this.queueId,
        group_id: this.item.dep.group_id,
      });
      this.lave_num = data.lave_num;
      this.can_num = data.can_num;
      this.allocation_times_sum = data.allocation_times_sum;
      this.form.allocation_times = this.item.allocation_times;
      this.form.allocation_status = this.item.allocation_status;
    },
  },
};
</script>

<style lang="scss" module>
</style>